/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */

import React from "react";
import { connect } from "react-redux";
import Swiper from "swiper";
import "../css/mobileGallery.css";
import DiscoveryIcon from "../images/discovery icon.svg";
import { enlargeImage } from "../models";
import { Translation } from "react-i18next";

let swiper;
let $ = window.$;

class MobileGallery extends React.Component {
  state = {
    openVideoDialog: false,
    play: true,
    bulletIsVideo: false
  };
  openVideo = () => {
    this.videoDialog.load();
    this.videoDialog.play();
    const length = swiper.slides.length;
    swiper.slideTo(length - 1);
  };
  closeVideo = e => {
    e.stopPropagation();
    this.setState({
      openVideoDialog: false,
      play: true
    });
  };
  componentDidMount() {
    const { video } = this.props;
    swiper = new Swiper(".gallery-mobile", {
      pagination: {
        el: ".gallery-mobile .swiper-pagination",
        clickable: true
      }
    });
    if (video) {
      // 若有影片時，將最後一個bullet移除
      const bullets = $(".swiper-pagination .swiper-pagination-bullet");
      const length = swiper.slides.length;
      const lastBullet = bullets[length - 1];
      if (lastBullet) {
        lastBullet.remove();
      }

      swiper.on("slideChange", () => {
        if (swiper.activeIndex === length - 1) {
          this.setState({ bulletIsVideo: true, play: true });
        } else {
          this.setState({ bulletIsVideo: false });
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { video } = this.props;
    if (
      prevProps.gallery &&
      this.props.gallery &&
      prevProps.gallery !== this.props.gallery
    ) {
      swiper.update();
      swiper.slideTo(0);
    }
    if (video) {
      // 若有影片時，將最後一個bullet移除
      const bullets = $(".swiper-pagination .swiper-pagination-bullet");
      const length = swiper.slides.length;
      const lastBullet = bullets[length - 1];
      if (lastBullet) {
        lastBullet.remove();
      }
    }
  }

  enlargeImage = img => {
    this.props.showEnlargeImage(img);
  };

  handleVideoPlay = () => {
    const { play } = this.state;
    if (play) {
      this.videoDialog.pause();
      this.setState({ play: false });
    } else {
      this.videoDialog.play();
      this.setState({ play: true });
    }
  };

  render() {
    const { gallery, video } = this.props;
    const { openVideoDialog, bulletIsVideo } = this.state;

    const VideoPlayBtn = () => {
      const { video } = this.props;

      if (!video) return;
      return (
        <button onClick={this.openVideo.bind(this)} className="mobileBtn">
          <div className="videoMobileBtn">
            <div className={`btnImg ${bulletIsVideo ? "active" : ""}`} />
            {/* <span className="btnImgText">播放</span> */}
          </div>
        </button>
      );
    };
    const VideoDialog = () => {
      if (this.state.openVideoDialog)
        return (
          <div className="videoDialog" onClick={this.handleVideoPlay}>
            <video
              preload="metadata"
              className="videoItem"
              ref={videoDialog => (this.videoDialog = videoDialog)}
              autoPlay
              key={this.props.video}
              playsInline
              loop
              muted
            >
              <source src={this.props.video} type="video/mp4" />
            </video>
            <div
              className="videoCloseBtn"
              onClick={this.closeVideo.bind(this)}
            />
            {!this.state.play && <div className="video-pause-commit-icon" />}
          </div>
        );
    };

    const url = window.location.pathname;
    const sku = url.substring(url.lastIndexOf("/") + 1);

    return (
      <div className="pdt_slider_m_wrap d-block d-md-none">
        <div className="swiper-container gallery-mobile demo-gallery">
          {VideoDialog()}
          <div className="swiper-wrapper">
            {gallery.map((img, index) => (
              <div key={index} className="swiper-slide">
                <a
                  data-size="1024x1024"
                  data-med=""
                  data-med-size="1024x1024"
                  className="swiper-slide demo-gallery__img--main"
                  onClick={this.enlargeImage.bind(this, img)}
                >
                  <img src={img.displayUrl}></img>
                </a>
                {/* 暫時移除syte相關模組 */}
                {/* <button
                  className="syte-discovery pdp-syte-discovery"
                  data-image-src={img.displayUrl}
                  data-sku={sku}
                  data-placement="product-detail-page"
                >
                  <img src={DiscoveryIcon} alt="" />
                </button> */}
              </div>
            ))}
            {video && (
              <div className="swiper-slide" onClick={this.handleVideoPlay}>
                <video
                  preload="metadata"
                  className="videoItem"
                  ref={videoDialog => (this.videoDialog = videoDialog)}
                  autoPlay
                  key={video}
                  playsInline
                  loop
                  muted
                >
                  <source src={video} type="video/mp4" />
                </video>
                {!this.state.play && (
                  <div className="video-pause-commit-icon" />
                )}
              </div>
            )}
          </div>
          {/* pagination 和 play btn 排成一列 */}
          <div className="pagination-video-playBtn">
            <div className="swiper-pagination" />
            {/*手機播放影片時, 隱藏video play button*/}
            {!openVideoDialog && VideoPlayBtn()}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    productLoading: state.product.loading,
    video: state.product.productBookingUnit.media.video
  };
};

const mapDispatchToProps = () => {
  return {
    showEnlargeImage: img => enlargeImage.actions.showEnlargeImage(img)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileGallery);
